export default defineNuxtPlugin(async () => {
  const nzSlugs = useState('nzSlugs', () => null)
  if (nzSlugs.value) return

  const { data } = await useAsyncData('nz-slugs-manifest', () => $fetch('/api/_nz-slugs'))
  nzSlugs.value = data.value || {}
})
